export default __webpack_public_path__ + "static/media/huvudentre_v7.0c8ab396.jpg";